import { ComponentBase } from "./ComponentBase.js";

export class DataProvider extends ComponentBase {
    constructor(config) {
        super(config);
        this.data = [];
        this.totalCount = 0;

        this.options = {
            pageSize: 25,
            dataUrl: null,
            rpcClass: null,
            autoLoad: true,
            context: null,
            listenToEvents: false,
            resolveReferences: true,
            fields: {}  // Add this line
        };

        // Merge default options with provided config
        this.config = { ...this.options, ...config };

        if (this.config.listenToEvents) {
            this.subscribeToEvents();
        }
    }

    async initialize() {
        if (this.config.autoLoad) {
            await this.loadData();
        }
    }

    async loadData(params = {}) {
        // To be implemented by subclasses
        throw new Error('loadData must be implemented by subclass');
    }

    getData() {
        return this.data;
    }

    setData(data, totalCount = null) {
        this.data = data;
        if (totalCount !== null) {
            this.totalCount = totalCount;
        }
        this.emit(`dataChanged`, { data: this.data, totalCount: this.totalCount });
    }

    refreshData() {
        return this.loadData();
    }

    getTotalCount() {
        return this.totalCount;
    }

    setTotalCount(totalCount) {
        this.totalCount = totalCount;
    }

    async insert(item) {
        // To be implemented by subclasses
        throw new Error('insert must be implemented by subclass');
    }

    async update(item) {
        // To be implemented by subclasses
        throw new Error('update must be implemented by subclass');
    }

    async delete(item) {
        // To be implemented by subclasses
        throw new Error('delete must be implemented by subclass');
    }

    subscribeToEvents() {
        this.on(`filterChanged`, async (filter) => {
            await this.loadData({ filter });
        });
    }

    unsubscribeFromEvents() {
        this.off(`filterChanged`);
    }

    async getDataCount(filter, context) {
        // To be implemented by subclasses
        throw new Error('getDataCount must be implemented by subclass');
    }

    async getNextSetOfData(startIndex, count, filter, context) {
        // To be implemented by subclasses
        throw new Error('getNextSetOfData must be implemented by subclass');
    }

    async getValueForId(id, field, context) {
        // To be implemented by subclasses
        throw new Error('getValueForId must be implemented by subclass');
    }

    async getFieldValues(field, filter, context) {
        // To be implemented by subclasses
        throw new Error('getFieldValues must be implemented by subclass');
    }

    destroy() {
        this.unsubscribeFromEvents();
        this.data = [];
        this.totalCount = 0;
    }
}
